import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Input } from './ui/input'
import { Button } from './ui/button'
import { Card, CardContent } from './ui/card'
import { useNavigate } from 'react-router-dom'

const BASE_URL = process.env.REACT_APP_API_URL || ''
const months = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December"
]

export default function Dashboard() {
  const [inputAgentId, setInputAgentId] = useState('')
  const [agentId,      setAgentId     ] = useState('')
  const [agentName,    setAgentName   ] = useState('')
  const [totalUnits,   setTotalUnits  ] = useState(null)
  const [hasError,     setHasError    ] = useState(false)
  const [selectedMonth, setSelectedMonth] = useState(new Date().getUTCMonth())
  const [selectedYear,  setSelectedYear ] = useState(new Date().getUTCFullYear())
  const navigate = useNavigate()

  useEffect(() => {
    if (!agentId) return

    const fetchData = async () => {
      try {
        const [gmRes, mobRes] = await Promise.all([
          axios.get(`${BASE_URL}/api/agents?id=${agentId}`),
          axios.get(`${BASE_URL}/api/mobility?id=${agentId}`)
        ])

        const gmData  = gmRes.data || []
        const mobData = (mobRes.data || []).map(m => ({
          ...m,
          SEGMENT: 'MOB',
          Units: 0.5,
          Activation_Date: m.GM_ACTIVATION_DT
        }))

        // display Agent_Name from the first GM record
        setAgentName(gmData[0]?.Agent_Name || '')

        const allInstalls = [...gmData, ...mobData].filter(item => {const d = new Date(item.Activation_Date)
        return d.getUTCMonth() === selectedMonth&& d.getUTCFullYear() === selectedYear
        })

        const total = allInstalls.reduce((sum, i) => sum + parseFloat(i.Units || 0), 0)
        setTotalUnits(total)
        setHasError(false)
      } catch (err) {
        console.error(err)
        setHasError(true)
        setTotalUnits(null)
      }
    }

    fetchData()
  }, [agentId, selectedMonth, selectedYear])

  const handleLoadData = async () => {
    const id = inputAgentId.trim().toUpperCase()
    if (!id) {
      setHasError(true)
      return
    }
    setHasError(false)
    setTotalUnits(null)

    try {
      // peek Agent_Name first
      const gmRes = await axios.get(`${BASE_URL}/api/agents?id=${id}`)
      setAgentName(gmRes.data?.[0]?.Agent_Name || '')
      setAgentId(id)
    } catch (err) {
      console.error("Agent lookup failed:", err)
      setHasError(true)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 text-white px-6 py-14">
      <div className="max-w-xl mx-auto backdrop-blur-sm bg-white/5 border border-white/10 rounded-2xl p-10 shadow-2xl">
        <h1 className="text-4xl font-bold tracking-tight text-center mb-2">Agent Dashboard</h1>
        <div className="space-y-4">
          <label htmlFor="agentId" className="block text-sm text-gray-300 font-medium">
            Enter Agent ID
          </label>
          <div className="flex flex-col md:flex-row gap-2">
            <Input
              id="agentId"
              className="flex-1 bg-white/80 text-black rounded-md px-4 py-2"
              placeholder="EQXXXXX"
              value={inputAgentId}
              onChange={e => {
                setHasError(false)
                setInputAgentId(e.target.value)
              }}
            />
            <select
              className="flex-1 bg-white/80 text-black rounded-md px-2 py-2"
              value={selectedMonth}
              onChange={e => setSelectedMonth(Number(e.target.value))}
            >
              {months.map((m,i) => (
                <option key={i} value={i}>{m}</option>
              ))}
            </select>
            <Button
              onClick={handleLoadData}
              className="flex-none bg-blue-600 hover:bg-blue-700 px-6 py-2 transition-all font-semibold"
            >
              Load
            </Button>
          </div>
          {hasError && (
            <p className="text-red-400 text-sm">
              Please enter a valid Agent ID and try again.
            </p>
          )}
        </div>

        {totalUnits !== null && (
          <>
            <Card className="bg-white/5 border border-white/10 mt-10 rounded-xl shadow-lg">
              <CardContent className="p-6 text-center">
                <p className="text-sm text-black-300">Total Units Installed</p>
                <p className="text-5xl font-bold mt-2 text-black">{totalUnits}</p>
              </CardContent>
            </Card>

            <div className="text-center mt-6">
              <div className="inline-flex flex-col md:flex-row gap-3">
                <Button
                  onClick={() =>
                    navigate(
                      `/orders?agentId=${agentId}&agentName=${encodeURIComponent(
                        agentName
                      )}&month=${selectedMonth}&year=${selectedYear}`
                    )
                  }
                  className="bg-blue-600 hover:bg-blue-700 px-6 py-2 text-white rounded-lg transition-all"
                >
                  Installations
                </Button>

                <Button
                  onClick={() =>
                    navigate(
                      `/sales?agentId=${agentId}&agentName=${encodeURIComponent(
                        agentName
                      )}&month=${selectedMonth}&year=${selectedYear}`
                    )
                  }
                  className="bg-blue-600 hover:bg-blue-700 px-6 py-2 text-white rounded-lg transition-all"
                >
                  Sales
                </Button>

                <Button
                  onClick={() =>
                    navigate(
                      `/commission?agentId=${agentId}&agentName=${encodeURIComponent(
                        agentName
                      )}&month=${selectedMonth}&year=${selectedYear}`
                    )
                  }
                  className="bg-blue-600 hover:bg-blue-700 px-6 py-2 text-white rounded-lg transition-all"
                >
                  Commission Tracker
                </Button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
